import { render, staticRenderFns } from "./address-book.vue?vue&type=template&id=7ee11dec&scoped=true"
import script from "./address-book.vue?vue&type=script&lang=js"
export * from "./address-book.vue?vue&type=script&lang=js"
import style0 from "./address-book.vue?vue&type=style&index=0&id=7ee11dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee11dec",
  null
  
)

export default component.exports